
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import TeamSection from './components/TeamSection';
import ServicesSection from './components/ServicesSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';
import SEOHead from '../../components/seo/SEOHead';

export default function Home() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "The Tooth Doctor – Best Denist Clinic Thiruverkadu",
    "description": "The Tooth Doctor offers advanced dental care in Thiruverkadu, Chennai. Expert dentists providing dental implants, root canal, cosmetic dentistry, orthodontics & more. Book appointment today!",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`,
    "mainEntity": {
      "@type": "DentalClinic",
      "name": "The Tooth Doctor - Advanced Dental Care Centre",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "No.9/3, First street, Thambu Swamy Nagar, Near Bus Stand",
        "addressLocality": "Thiruverkadu",
        "addressRegion": "Tamil Nadu",
        "postalCode": "600077",
        "addressCountry": "IN"
      },
      "telephone": "+91-6369090441",
      "email": "toothdoctor.in@gmail.com",
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "13.0827",
        "longitude": "80.2707"
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "09:00",
          "closes": "22:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Saturday",
          "opens": "09:00",
          "closes": "21:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Sunday",
          "opens": "16:00",
          "closes": "21:00"
        }
      ],
      "priceRange": "$$",
      "paymentAccepted": ["Cash", "Credit Card", "Debit Card"],
      "currenciesAccepted": "INR",
      "hasMap": "https://maps.app.goo.gl/6qXmz1Czz8z8tKkx7",
      "medicalSpecialty": [
        "General Dentistry",
        "Cosmetic Dentistry",
        "Orthodontics",
        "Oral Surgery",
        "Endodontics",
        "Periodontics",
        "Pediatric Dentistry",
        "Prosthodontics"
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "reviewCount": "200",
        "bestRating": "5",
        "worstRating": "1"
      }
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`
        }
      ]
    }
  };

  return (
    <div className="min-h-screen">
      <SEOHead
        title="The Tooth Doctor – Best Denist Clinic Thiruverkadu"
        description="The Tooth Doctor offers advanced dental care in Thiruverkadu, Chennai. Expert dentists providing dental implants, root canal, cosmetic dentistry, orthodontics & more. Book appointment today!"
        keywords="dentist Thiruverkadu, dental clinic Chennai, dental implants, root canal treatment, cosmetic dentistry, orthodontics, teeth whitening"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}`}
        ogTitle="The Tooth Doctor – Best Denist Clinic Thiruverkadu"
        ogDescription="The Tooth Doctor offers advanced dental care in Thiruverkadu, Chennai. Expert dentists providing dental implants, root canal, cosmetic dentistry, orthodontics & more. Book appointment today!"
        ogUrl={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}`}
        ogImage={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/og-home.jpg`}
        twitterTitle="The Tooth Doctor – Best Denist Clinic Thiruverkadu"
        twitterDescription="The Tooth Doctor offers advanced dental care in Thiruverkadu, Chennai. Expert dentists providing dental implants, root canal, cosmetic dentistry, orthodontics & more. Book appointment today!"
        twitterImage={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/twitter-home.jpg`}
        jsonLd={jsonLd}
      />
      <HeroSection />
      <AboutSection />
      <TeamSection />
      <ServicesSection />
      <TestimonialsSection />
      <ContactSection />
    </div>
  );
}
